// extracted by mini-css-extract-plugin
module.exports = {"fixedBinConfirm":"styles_fixedBinConfirm__3xRao"};